<template>
  <div class="row">
              <div class="col">
              <h2>Kulture na zahtevku</h2>
                <Grid  
                        :data-items="dataKmrs"
                        :columns="columnsKmrs"
                  >      
                 </Grid>
              </div>
              <div class="col">
               <h2>Stanje GERK-a v RKG</h2>
                <Grid  
                        :data-items="dataGerkRKG"
                        :columns="columnsGerk"
                  >      
                 </Grid>
              </div>
              <div class="col">
               <h2>Stanje GERK-a na zahtevku</h2>
                <Grid  
                        :data-items="dataGerkZS"
                        :columns="columnsGerk"
                  >      
                 </Grid>
              </div>
              <div v-if="this.userDetails.pravice.includes('STATISTIKA_BERI')" class="col">
              <h2>Pretekla izplačila</h2>
                 <Grid  
                        :data-items="dataGerkHistory"
                        :columns="columnsGerkHistory"
                  >      
                 </Grid>
              </div>
              </div>
              </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import { Grid} from '@progress/kendo-vue-grid';
import { process } from '@progress/kendo-data-query';
export default {
  props: {
    field: String,
        dataItem: Object,
        sezona:Object  
  },
  created () {
    var thisComp=this;
    this.load(this.dataItem).then(()=>
          {
             thisComp.dataKmrs=process( thisComp.kmrs, {});
    });
     this.loadGerkZS(this.dataItem).then(()=>
          {
             thisComp.dataGerkZS=process( thisComp.gerkZS, {});
    });
      this.loadGerkRKG(this.dataItem).then(()=>
          {
             thisComp.dataGerkRKG=process( thisComp.gerkRKG, {});
    });
    if(this.userDetails.pravice.includes("STATISTIKA_BERI"))
        this.loadHistory(this.dataItem).then(()=>{
             thisComp.dataGerkHistory=process( thisComp.gerkHistory, {});
        });
   
    },
  data () {
        return {
          dataKmrs:null,
          dataGerkRKG:null,
          dataGerkZS:null,
          dataGerkHistory:null,
          columnsKmrs: [
                { field: "opis", title:"Kultura"},
                { field: "povrsina", title:"Površina",type:"numeric", format:"{0:n4}"},
            ],
          columnsGerkHistory: [
                { field: "sezona", title:"Sezona"},
                { field: "znesek", title:"Znesek",type:"numeric", format:"{0:c}"},
                { field: "zahtevek", title:"Zahtevek"},
                { field: "kmgmid", title:"KMGMID"},
            ],
            columnsGerk: [
                { field: "gerkpid", title:"GERKPID"},
                { field: "povrsina", title:"Površina",type:"numeric",format:"{0:n4}"},
                { field: "raba", title:"Raba"}
               
            ],


        }
    },     
    computed:{
      ...mapState('kmrs', ['kmrs','gerkRKG','gerkZS']),         
      ...mapState('gerkHistory', ['gerkHistory']),
       ...mapState('users', ['userDetails']),
    },
    methods: {
      ...mapActions('gerkHistory', ['loadHistory']),
      ...mapActions('kmrs', ['load','loadGerkZS','loadGerkRKG']),
      
    }
  }
  

</script>